import { render, staticRenderFns } from "./AlmoxarifadoDashboard.vue?vue&type=template&id=28fcbbb2&scoped=true"
import script from "./AlmoxarifadoDashboard.vue?vue&type=script&lang=js"
export * from "./AlmoxarifadoDashboard.vue?vue&type=script&lang=js"
import style0 from "./AlmoxarifadoDashboard.vue?vue&type=style&index=0&id=28fcbbb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcbbb2",
  null
  
)

export default component.exports